import gaTracking from './google';
import wpTracking from './wp';
import viewTracking from './views';

export default function (player) {
  viewTracking(player);

  if (!window?.prestoPlayer?.isPremium) {
    return;
  }
  gaTracking();
  wpTracking(player);
}
